import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NzFormModule } from 'ng-zorro-antd/form';
import { NzInputModule } from 'ng-zorro-antd/input';
import { FormV1Component } from './form-v1.component';
import { NgxImageCompressService } from 'ngx-image-compress';
import { NgxFileDropModule } from 'ngx-file-drop';
import { NzDividerModule } from 'ng-zorro-antd/divider';
import { DateInputModule } from '../date-input/date-input.module';
import { NzRadioModule } from 'ng-zorro-antd/radio';
import { NzSelectModule } from 'ng-zorro-antd/select';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { NzCheckboxModule } from 'ng-zorro-antd/checkbox';
import { NzInputNumberModule } from 'ng-zorro-antd/input-number';
import { PhoneInputModule } from '../phone-input/phone-input.module';
import { OntarioHcModule } from '../ontario-hc/ontario-hc.module';
import { NzSwitchModule } from 'ng-zorro-antd/switch';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { CreditCardModule } from '../credit-card/credit-card.module';

@NgModule({
  declarations: [FormV1Component],
  providers: [NgxImageCompressService],
  imports: [
    CommonModule,
    NzFormModule,
    NzInputModule,
    NzInputNumberModule,
    FormsModule,
    ReactiveFormsModule,
    NgxFileDropModule,
    NzDividerModule,
    DateInputModule,
    PhoneInputModule,
    NzRadioModule,
    NzSelectModule,
    OntarioHcModule,
    CreditCardModule,
    NzIconModule,
    NzCheckboxModule,
    NzSwitchModule,
    NzButtonModule
  ],
  exports: [FormV1Component]
})
export class FormV1Module {}
